import * as React from "react";
const SvgSymbolicpauseBgWhite = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36" {...props}><circle cx={18} cy={18} r={18} fill="#fff" style={{
    fill: "#fff",
    fillOpacity: 1
  }} /><path d="M15.103 13.52v9.46M21.137 13.52v9.46" style={{
    fill: "currentColor",
    fillOpacity: 1,
    stroke: "currentColor",
    strokeWidth: 3.02362,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "none",
    strokeOpacity: 1
  }} /></svg>;
export default SvgSymbolicpauseBgWhite;